import { useContext } from "react";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import CmsContext from "../../Context/CmsContext";
import { useEffect } from "react";
import ApiService from "../../Core/Service/ApiService";
import { CmsType } from "../../Constants/constants";
import { useState } from "react";
import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle, MDBCheckbox, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import { LondonDate, validateForm } from "../../Utils/utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Ribbon from "../../Components/CMS/Ribbon";
import ColorPicker from "../../Components/CMS/ColorPicker";
import BranchSelect from "../../Components/CMS/BranchSelect";
import PriceSelect from "../../Components/CMS/PriceSelect";

const ShopByCategory = () => {
    const navigate = useNavigate();
    const cmsContext = useContext(CmsContext);
    const now = LondonDate(new Date());
    const [formData, setFormData] = useState({
        type: CmsType.Shop_By_Category,
        active: false,
        start_date: LondonDate(new Date(`${now.year()}-${now.month() + 1}-${now.date()} 00:00:00`)),
        end_date: LondonDate(new Date(`${now.year()}-${now.month() + 1}-${now.date()} 23:59:59`)),
        page_pos: 0,
        branches: [],
        price_list: [],
        organization_id: '',
        template_id: '',
        ribbon: {
            content: '',
            bg_color: '#f00',
            txt_color: '#fff',
            align: 'left',
        },
        data: {}
    });
    const rules = {
        start_date: {required: 'date'},
        end_date: {required: 'date'},
        page_pos: {required: 'number'},
        organization_id: {required: 'number'},
        branches: {required: 'array'},
        price_list: {required: 'array'},
    }
    const [inputErrors, setInputErrors] = useState({});
    const [organizations, setOrganizations] = useState([]);
    const [templateOptions, setTemplateOptions] = useState();
    const [saving, setSaving] = useState(false);

    const loadData = async () => {
        const orgResp = await ApiService.get('/organizations/all');
        const orgs = orgResp.data.organizations ?? [];
        setOrganizations(orgs.map(org => ({value: org.id, label: org.name})));

        ApiService.get('/templates/all').then(response=>{
            const ts = response.data.templates;
            ts.unshift({
                id: '', internal_name: '- None -'
            });
            setTemplateOptions(ts.map(t=>(
                {value: t.id, label: t.internal_name}
            )));
        })

        ApiService.get('/cms', {type: CmsType.Shop_By_Category}).then(response => {
            if(response.data.rows?.length > 0) {
                const row = response.data.rows[0];
                setFormData(prev => ({
                    ...prev,
                    ...row,
                    active: (row.active == "1") ? true : false,
                    start_date: row.start_date ? LondonDate(new Date(row.start_date)) : prev.start_date,
                    end_date: row.end_date ? LondonDate(new Date(row.end_date)) : prev.end_date,
                    branches: row.branches ? row.branches.split(',') : [],
                    price_list: row.price_list ? row.price_list.split(',') : [],
                    organization_id: row.organization_id ?? '',
                    ribbon: row.ribbon ? JSON.parse(row.ribbon) : {},
                    data: row.data ? JSON.parse(row.data) : {},
                }));
            }
        })
    }

    useEffect(() => {
        cmsContext.setBreadcrumb([
            {title: 'Shop by Category'},
        ]);

        loadData();
    }, [])

    const handleCheckChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.checked
        })
    }
    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }
    const handleSelectChange = (opt, target) => {
        setFormData({
            ...formData,
            [target]: opt.value
        })
    }
    const handleDateChange = (d, target) => {
        setFormData({
            ...formData,
            [target]: d
        })
    }
    const handleBranchChange = (branches) => {
        setFormData({
            ...formData,
            branches
        })
    }
    const handlePriceChange = (price_list) => {
        setFormData({
            ...formData,
            price_list
        })
    }
    const setRibbon = (ribbon) => {
        setFormData({
            ...formData,
            ribbon: ribbon
        })
    }

    const goBack = () => {
        navigate(-1);
    }

    const handleSave = async () => {
        const ret = validateForm(formData, rules);
        if (ret.result) {
            setInputErrors({});
            setSaving(true);

            const data = {
                ...formData,
                branches: formData.branches?.join(','),
                price_list: formData.price_list?.join(','),
                ribbon: JSON.stringify({
                    bg_color: '#f00',
                    txt_color: '#fff',
                    align: 'left',
                    ...formData.ribbon
                }),
                data: JSON.stringify(formData.data),
            }

            if(formData.id) {
                await ApiService.put(`/cms/${formData.id}`, data);
            } else {
                await ApiService.post('/cms', data);
            }

            toast.success("Operation Success");
            setSaving(false);
        } else {
            setInputErrors(ret.errors);
        }
    }

    const renderCommon = () => {
        return (
        <MDBCard>
            <MDBCardHeader>
                <MDBCardTitle>Common</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <div className="d-flex align-items-center flex-wrap">
                    <div className="me-4" title="Start date when CMS content is displayed">
                        <label className="required">Start Date:</label>
                        <div>
                            <DateTimePicker
                                onChange={d => handleDateChange(d, 'start_date')}
                                value={formData.start_date}
                                format="y/MM/dd HH:mm:ss"
                                disableClock={true}
                            />
                        </div>
                        {inputErrors?.start_date && <div className="error">{inputErrors.start_date}</div>}
                    </div>
                    <div className="me-4" title="End date when CMS content is displayed">
                        <label className="required">End Date:</label>
                        <div>
                            <DateTimePicker
                                onChange={d => handleDateChange(d, 'end_date')}
                                value={formData.end_date}
                                format="y/MM/dd HH:mm:ss"
                                disableClock={true}
                            />
                        </div>
                        {inputErrors?.end_date && <div className="error">{inputErrors.end_date}</div>}
                    </div>
                    <div className="me-4" title="Organization">
                        <label className="required">Organization:</label>
                        <div style={{ width: 200 }}>
                            <Select
                                options={organizations}
                                value={organizations.find(opt => opt.value == formData.organization_id)}
                                onChange={opt => handleSelectChange(opt, 'organization_id')}
                            />
                        </div>
                        {inputErrors?.organization_id && <div className="error">{inputErrors.organization_id}</div>}
                    </div>
                    <div className="me-4">
                        <div className="d-flex align-items-center">
                            <label className="me-2 required">Page Position:</label>
                            <div style={{ width: 100 }}>
                                <MDBInput name="page_pos" value={formData.page_pos ?? 0} onChange={handleInputChange} type="number" className="text-center" />
                            </div>
                        </div>
                        {inputErrors?.page_pos && <div className="error">{inputErrors.page_pos}</div>}
                    </div>
                    <div className="me-4 d-flex align-items-center">
                        <label className="me-2">Template:</label>
                        <div style={{width: 150}}>
                            <Select options={templateOptions}
                                value={templateOptions?.find(opt => opt.value == formData.template_id)}
                                onChange={opt=>handleSelectChange(opt, 'template_id')}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <label className="me-2">Active:</label>
                        <MDBCheckbox name="active" checked={formData.active} onChange={handleCheckChange} title='Activate/Deactivate the CMS content' />
                    </div>
                </div>
            </MDBCardBody>
        </MDBCard>
        )
    }

    const renderBranchAndPriceList = () => {
        return (
        <MDBCard className="mt-4">
            <MDBCardHeader>
                <MDBCardTitle>Branch & Price List</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <BranchSelect
                    className=""
                    initialSelectedBranches={formData.branches}
                    onChange={handleBranchChange}
                    required={true}
                    inputError={inputErrors?.branches}
                />

                <PriceSelect
                    className="mt-4"
                    initialSelectedPrices={formData.price_list}
                    onChange={handlePriceChange}
                    required={true}
                    inputError={inputErrors.price_list}
                />
            </MDBCardBody>
        </MDBCard>
        )
    }

    return (
    <div className="p-4">
        { renderCommon() }

        { renderBranchAndPriceList() }

        <Ribbon ribbon={formData.ribbon ?? {}} setRibbon={setRibbon} />

        <MDBCard className="mt-4">
            <MDBCardBody>
                <ColorPicker
                    label="Label Color: "
                    color={formData.data?.label?.txt_color}
                    setColor={(color) => {
                        setFormData({
                            ...formData,
                            data: {
                                ...formData.data,
                                label: {
                                    txt_color: color
                                }
                            }
                        })
                    }}
                />
            </MDBCardBody>
        </MDBCard>

        <div className="mt-4 d-flex justify-content-end">
            <MDBBtn color="default" onClick={goBack}>Back</MDBBtn>
            <MDBBtn className="ms-2 united-cms-primary-btn" onClick={handleSave}>
                {saving && <MDBSpinner size="sm" className="me-1" />}
                Save
            </MDBBtn>
        </div>
    </div>
    )
}

export default ShopByCategory;
